import { JourneyPlannerFiltersSettings } from '@ridango/core/env';
import { Route } from './open-trip-planner.model';

export interface JourneyPlannerFilter {
    transportModes?: string[];
    transportModesValue?: number;
    routes?: string[];
    [key: string]: string | string[] | number;
}

export function getDefaultValue(filterConfig: JourneyPlannerFiltersSettings): JourneyPlannerFilter {
    const value: JourneyPlannerFilter = { routes: [], viaPointId: null, transportModesValue: 0, transportModes: [] };

    filterConfig?.SELECTORS.forEach((selector) => {
        switch (selector.TYPE) {
            case 'MULTI_SELECTION':
                value[selector.QUERY_PARAMETER] = selector.VALUES.filter((v) => v.SELECTED_BY_DEFAULT).map(
                    (v) => v.VALUE as string
                );
                break;
            case 'SINGLE_SELECTION':
                value[selector.QUERY_PARAMETER] = selector.VALUES.find((v) => v.SELECTED_BY_DEFAULT)?.VALUE || null;
                break;
            case 'SLIDER': {
                const defaultIndex = selector.VALUES.findIndex((v) => v.SELECTED_BY_DEFAULT);
                value[selector.QUERY_PARAMETER] = defaultIndex >= 0 ? defaultIndex : 0;
                break;
            }
            default:
                break;
        }
    });

    return value;
}

export interface ExtendedRoute extends Route {
    selected?: boolean;
}
